<template>
  <div class="order">
    <van-sticky>
      <van-nav-bar title="订单" />
      <van-search v-model="searchValue" show-action placeholder="搜索已租赁的场地，订单号" @clear="onCancel()">
        <template #action>
          <div @click="onClickButton">搜索</div>
        </template>
      </van-search>
    </van-sticky>
    <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
        <div class="order_centent">
          <van-tabs v-model="active" title-active-color="#2295ff" color="#2295ff" @click="onClickTabs">
            <van-tab :badge="badgeNumber > 0 && index === 2 ? badgeNumber : ''" v-for="(item, index) in title"
              :key="index" :title="item">
              <template v-for="(items, indexs) in orderList">
                <div class="order_list" :key="indexs">
                  <div class="list_ordernum">
                    <div>订单编号：{{ items.orderNumber }}</div>
                    <span>{{ items.status_name }}</span>
                  </div>
                  <!-- 订单详情 -->
                  <div class="list_detail" @click="onOrderDetail(items.id)">
                    <van-image height="80" width="80" :src="items.siteVo.coverImageUrl" fit="cover" radius="7" />
                    <div class="list_desc fs11 color999">
                      <div class="line2 fs16 color000">
                        {{ items.site_name }}
                      </div>
                      <p>
                        面积：{{ items.siteVo.area }}㎡
                        {{ items.siteVo.rentFree }}
                      </p>
                      <div>下单时间：{{ items.createtime }}</div>
                    </div>
                    <span class="fs12 coloree0a24">{{ items.payablePrice }}元</span>
                  </div>
                  <div class="list_btn" v-if="items.status === '1'">
                    <van-button size="small" plain type="default" @click="toCancelOrder(items.id)">取消订单</van-button>

                    <!-- <van-button size="small" type="warning" @click="toCancelRefund(items.id)">退款申请</van-button> -->

                    <van-button size="small" type="info" @click="jsapiUnifiedorder(items.id)">立即付款</van-button>
                  </div>
                  <div class="list_btn" v-if="items.status === '2'">
                    <!-- <van-button size="small" plain type="default" @click="toCancelOrder(items.id)">取消订单</van-button> -->
                    <van-button size="small" v-if="active != 4 && active != 5 && active != 6 && items.status != 4 && items.status != 5 && items.status != 6" type="warning" @click="toCancelRefund(items.id)">退款申请</van-button>
                    <van-button size="small" type="info">确定中</van-button>
                  </div>
                  <div class="list_btn" v-if="items.status === '3'">
                    <!-- <van-button size="small" plain type="default" @click="toCancelOrder(items.id)">取消订单</van-button> -->
                    <van-button size="small" v-if="active != 4 && active != 5 && active != 6 && items.status != 4 && items.status != 5 && items.status != 6" type="warning" @click="toCancelRefund(items.id)">退款申请</van-button>
                    <van-button size="small" color="#FFA001" @click="onContractData(items.id)">上传资料</van-button>
                    <van-button size="small" type="primary" @click="onContractBrowse(items.id)">合同浏览</van-button>
                  </div>
                  <div class="list_btn" v-if="items.status === '4'">
                    <van-button size="small" v-if="active != 4 && active != 5 && active != 6 && items.status != 4 && items.status != 5 && items.status != 6" type="warning" @click="toCancelRefund(items.id)">退款申请</van-button>
                    <van-button size="small" color="#FFA001" @click="onAppointmentData(items.id)">登记税务/工商/银行上门时间
                    </van-button>
                    <van-button size="small" type="info" @click="onEvaluate(items.id)">评价</van-button>
                    <van-button size="small" type="primary" @click="onContractBrowse(items.id)">合同浏览</van-button>
                    <van-button size="small" color="#FFA001" @click="onContractData(items.id)">上传资料</van-button>
                  </div>
                  <div class="list_btn" v-if="items.status === '5'">
                    <van-button size="small" v-if="active != 4 && active != 5 && active != 6 && items.status != 4 && items.status != 5 && items.status != 6" type="warning" @click="toCancelRefund(items.id)">退款申请</van-button>
                    <van-button size="small" color="#FFA001" @click="onContractData(items.id)">上传资料</van-button>
                    <van-button size="small" color="#FFA001" @click="onAppointmentData(items.id)">登记税务/工商/银行上门时间
                    </van-button>
                    <van-button size="small" type="primary" @click="onContractBrowse(items.id)">合同浏览</van-button>
                  </div>
                  <div class="list_btn btn" v-if="items.status === '6'">
                    <div v-if="items.subStatus === '1' || items.subStatus === '2'">{{items.subStatus_name}}</div>
                    <div v-if="items.subStatus === '3' && items.subHandleStatus === '0'">退款中</div>
                    <div v-if="items.subStatus === '3' && items.subHandleStatus === '1'">已退款</div>
                    <van-button size="small" color="#D7D7D7" @click="orderInfoUserH5Delete(items.id)">删除</van-button>
                  </div>
                </div>
              </template>
            </van-tab>
          </van-tabs>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-overlay :show="showOverlay" @click="show = false">
      <div class="mask_loading">
        <van-loading color="#0094ff" vertical>加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import storage from "@/utils/storage";
import {
  Button,
  Icon,
  Image,
  Search,
  Tab,
  Tabs,
  List,
  PullRefresh,
  Overlay,
  Dialog,
} from "vant";

export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Search.name]: Search,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Overlay.name]: Overlay,
  },
  data() {
    return {
      showOverlay: false,
      searchValue: "",
      active: 0,
      title: [
        "全部",
        "待付款",
        "待接单",
        "合同制作中",
        "待评价",
        "已完成",
        "售后/退款",
      ],
      badgeNumber: 0,
      params: {
        status: "",
        keyword: "",
        page: 1,
        size: 8,
      },
      //订单列表
      orderList: [],
      loading: false, //底部加载状态
      finished: false, //底部是否完成状态
      refreshing: false,
    };
  },

  created() {
    let that = this;
    if (that.GetQueryString("access_token")) {
      let token = "Bearer " + that.GetQueryString("access_token");
      storage.setToken(token); //设置请求头值
      storage.setUserInfo(token); //设置请求头值
      setTimeout(() => {
        // 订单-列表
        that.orderInfoUserH5List();
      }, 2000);
    } else {
      // 订单-列表
      that.orderInfoUserH5List();
    }
  },

  methods: {
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    wxPay(data) {
      let that = this;
      wx.config({
        debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timeStamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名，见附录1
        jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      wx.ready(function () {
        wx.chooseWXPay({
          timestamp: data.timestamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
          nonceStr: data.noncestr, // 支付签名随机串，不长于 32 位
          package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: data.signType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
          paySign: data.paySign, // 支付签名
          success: (res) => {
            if (res.errMsg === "chooseWXPay:ok") {
              that.$Notify({
                type: "success",
                message: "支付成功",
              });
              //下拉刷新
              that.onRefresh();
            } else {
              that.$Notify({
                type: "warning",
                message: "支付失败",
              });
            }
            // 支付成功后跳转到显示页面
          },
          cancel: (res) => {
            that.$Notify({
              type: "warning",
              message: "取消支付",
            });
          },
          fail: (res) => {
            that.$Notify({
              type: "warning",
              message: "支付失败",
            });
          },
        });
      });
      // 验签错误或者其他错误
      wx.error(function (res) {
        that.$Notify({
          type: "warning",
          message: "支付错误！",
        });
      });
    },

    //下拉刷新
    onRefresh() {
      var that = this;
      setTimeout(() => {
        that.params.page = 1;
        // 订单-列表
        that.orderInfoUserH5List();
        that.refreshing = false;
        that.finished = false;
      }, 1000);
    },

    //上拉加载
    onLoad() {
      var that = this;
      setTimeout(() => {
        that.orderInfoUserH5List();
      }, 1000);
    },

    // 订单-列表
    orderInfoUserH5List() {
      var that = this;
      that.$Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });

      if (that.active === 0) that.params.status = "";
      else that.params.status = that.active;
      that.$api
        .orderInfoUserH5ListAPI(that.params)
        .then(function (res) {
          if (res.data.code === 200) {
            // 如果是第一次进入页面page==1 直接赋值
            if (that.params.page === 1) {
              that.orderList = res.data.dataList;
            } else {
              that.orderList = [...that.orderList, ...res.data.dataList];
            }
            // 订单-列表
            that.getbadgeNumber();
            // 当还有数据是page++
            if (res.data.dataList.length > 0) {
              that.params.page++;
              that.loading = false;
            } else {
              // 如果没有数据加载完毕
              that.finished = true;
            }
          }
          that.$Toast.clear();
        })
        .catch(function (err) {
          console.log("error");
          that.$Toast.clear();
        });
    },

    // 订单-列表
    getbadgeNumber() {
      var that = this;
      that.$api
        .orderInfoUserH5ListAPI({
          status: "2",
          keyword: "",
          page: 1,
          size: 8,
        })
        .then(function (res) {
          if (res.data.code === 200) {
            that.badgeNumber = res.data.total;
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //订单-删除
    orderInfoUserH5Delete(id) {
      var that = this;
      //下拉刷新
      that.onRefresh();
      that.$api
        .orderInfoUserH5DeleteAPI({ id: id })
        .then(function (res) {
          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "操作成功",
            });
          } else {
            that.$Notify({
              type: "warning",
              message: res.data.message,
            });
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    jsapiUnifiedorder(id) {
      var that = this;
      that.$api
        .jsapiUnifiedorderAPI({ order_info_id: id })
        .then(function (res) {
          if (res.data.code === 200) {
            if(res.data.data.is_need_pay === "1")
              that.onBridgeReady(res.data.data);
            if(res.data.data.is_need_pay === "0")
              that.$router.push({ path: "/home/playSuccess" });
          } else {
            that.$Notify({
              type: "warning",
              message: res.data.message,
            });
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    onBridgeReady(data = "") {
      console.log(data);
      if (data == "") return false;
      let that = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: data.appId, //公众号ID，由商户传入
          timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: data.nonceStr, //随机串
          package: data.package,
          signType: data.signType, //微信签名方式：
          paySign: data.paySign, //微信签名
        },
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            that.onRefresh();
            window.location.reload();
          } else {
            Dialog.alert({
              title: '提示',
              message: '请及时支付!',
            }).then(() => {
            });
          }
        }
      );
    },

    checkWeixinJSBridge() {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
        }
      } else {
        this.onBridgeReady();
      }
    },

    onClickTabs(name, title) {
      this.active = name;
      this.params.page = 1;
      // 订单-列表
      this.orderInfoUserH5List();
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    //跳转订单详情界面
    onOrderDetail(id) {
      this.$router.push({ path: "/order/orderDetail", query: { id: id } });
    },

    //跳转合同资料补全界面
    onContractData(id) {
      this.$router.push({ path: "/order/contractData", query: { id: id } });
    },

    //跳转合同浏览界面
    onContractBrowse(id) {
      this.$router.push({ path: "/order/contractBrowse", query: { id: id } });
    },

    //跳转评价界面
    onEvaluate(id) {
      this.$router.push({ path: "/order/evaluate", query: { id: id } });
    },

    //跳转预约上门时间界面
    onAppointmentData(id) {
      this.$router.push({ path: "/order/appointmentData", query: { id: id } });
    },

    //提交搜索条件
    onClickButton() {
      this.params.keyword = this.searchValue;
      this.params.page = 1;
      // 订单-列表
      this.orderInfoUserH5List();
    },

    //点击去掉输入框
    onCancel() {
      this.params.keyword = "";
      this.params.page = 1;
      // 订单-列表
      this.orderInfoUserH5List();
    },

    //取消订单
    toCancelOrder(id) {
      this.$router.push({ name: "CancelOrder", params: { id: id } });
    },

    toCancelRefund(id){
  this.$router.push({ name: "CancelRefund", params: { id: id } });
    },
  },
};
</script>
<style lang="less" scoped>
.order {
  .order_centent {
    padding: 10px;

    .van-search {
      padding: unset;
    }

    /deep/ .van-search__action {
      background: #2295ff;
      color: #fff;
      border-radius: 0px 5px 5px 0px;
    }
  }

  .order_list {
    border-bottom: 1px solid #f3f3f3;
    padding: 20px 10px;

    .list_ordernum {
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        color: #ff5151;
        font-size: 11px;
      }
    }

    // 订单详情
    .list_detail {
      display: flex;
      padding: 15px 0px;
      justify-content: space-between;

      .list_desc {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 200px;
      }
    }

    .list_btn {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-wrap:wrap;
      .van-button {
        margin-left: 7px;
        margin-top: 5px;
      }
    }

    .btn {
      font-size: 11px;
      color: #000;

      /deep/ .van-button {
        color: #333 !important;
      }
    }
  }
}

.mask_loading {
  position: fixed;
  top: 50%;
  right: 0;
  left: 0;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/order/index.vue